import { CSSObject, Theme, keyframes } from '@emotion/react';

const popIn = keyframes`
  from { opacity: 0; transform: scale(0.96); }
  to { opacity: 1; transform: none; }
`;

const wrap = (theme: Theme): CSSObject => ({
  width: 340,
  maxWidth: '100%',
  boxSizing: 'border-box',
  padding: '28px 20px 20px',
  background: theme.color.white,
  borderRadius: theme.radius.xl + 4,
  boxShadow: theme.shadow.modal,
  animation: `${popIn} 0.18s ease-out`,
});

const content = (theme: Theme): CSSObject => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '4px 4px 24px',
  whiteSpace: 'pre-wrap',
  wordBreak: 'keep-all',
  textAlign: 'center',
  fontSize: '16px',
  fontWeight: 500,
  lineHeight: 1.55,
  color: theme.color.text,
});

const buttonArea = (theme: Theme): CSSObject => ({
  display: 'flex',
  gap: 8,
  '> button': {
    flex: 1,
    height: '52px',
    borderRadius: theme.radius.md + 2,
    fontWeight: 600,
    fontSize: '16px',
    textAlign: 'center',
    color: theme.color.white,
    background: theme.color.primary,
    transition: 'background-color 0.15s ease',
    ':hover': {
      background: theme.color.primaryHover,
    },
  },
});

export { wrap, content, buttonArea };
